import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

export const PhoneBtn = () => {
  return (
    <a
      href="tel:678-218-9315"
      rel="noreferrer"
      target="_blank"
      className="btn phone-btn"
    >
      678-218-9315
    </a>
  );
};

export const Navigation = ({ onNavigate }) => {
  const handleClick = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  return (
    <nav>
      <ul>
        <li>
          <Link to="/" onClick={handleClick}>
            Home
          </Link>
        </li>
        <li>
          <HashLink to="/#services" onClick={handleClick}>
            Services
          </HashLink>
        </li>
        <li>
          <HashLink to="/#process" onClick={handleClick}>
            Process
          </HashLink>
        </li>
        <li>
          <HashLink to="/#testimonials" onClick={handleClick}>
            Our Work
          </HashLink>
        </li>
        <li>
          <HashLink to="/#contact" onClick={handleClick}>
            Contact
          </HashLink>
        </li>
        <li>
          <PhoneBtn />
        </li>
      </ul>
    </nav>
  );
};
